import { memo, useRef, useState } from "react"
import redirectURL from "../redirectURL";

const BulkUploadHL = (props) => {

    const [slider, setSlider] = useState('')
    const [overlay, setOverlay] = useState('show-n')
    const [loader, setLoader] = useState('show-n')
    const [file, setFile] = useState('')
    const fileRef = useRef(null)

    const bulkUploadClick = () => {
        setSlider('slider-translate-40p')
        setOverlay('show-m')
    }

    const submitEventHandler = async (e) => {
        e.preventDefault()
        setLoader('show-m')
        let formData = new FormData()
        formData.append('uploadFile', file)
        await redirectURL.post("/uploadBulkHotLoads", formData, {
            headers: {
                'content-type': 'multipart/form-data'
            }
        })
            .then(response => {
                if (response.data.status == "success") {
                    props.setShow(true)
                    props.setTitle(response.data.message)
                    props.setType("success")
                    setLoader("show-n")
                    setSlider('')
                    setOverlay("show-n")
                    setFile('')
                    fileRef.current.value = ''
                }
                else {
                    props.setShow(true)
                    props.setTitle(response.data.message)
                    props.setType("danger")
                    setLoader("show-n")
                    setOverlay("show-n")
                }
            })
            .catch(err => console.log(err))
    }

    const closeSlider = () => {
        setSlider('')
        setFile('')
        setOverlay('show-n')
        fileRef.current.value = ''
    }
    const resetUpload = () => {
        setFile('')
        fileRef.current.value = ''
    }
    return (
        <>
            <div className={"slide-r " + slider} style={{ overflow: "hidde" }}>
                <div className="slide-r-title">
                    <h4>
                        Bulk Upload Hot Loads
                        <span className="float-right closebtn" style={{ marginRight: "25px" }} onClick={closeSlider} >X</span>
                    </h4>
                </div>
                <div className="slide-r-body" style={{ position: "relative" }}>
                    <div className={"dataLoad " + (loader)} style={{ opacity: "0.5" }}>
                        <div style={{ position: "fixed", left: "50%", top: '50%' }}>
                            <div class="loader-box">
                                <div class="loader-box">
                                    <div class="rotate dashed colored"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container-fluid">
                        <form id="upform" className="theme-form" onSubmit={submitEventHandler}>
                            <div className="form-group mt-20p">
                                <label className="">Upload File</label>
                                <input type="file" ref={fileRef} name="uploadFile" onChange={e => setFile(e.target.files[0])} className="form-control" required />
                            </div>
                            <div className="form-group">
                                <button type="submit" className="btn btn-success">Submit</button>
                                <button type="button" onClick={resetUpload} className="btn btn-default">Cancel</button>
                            </div>
                        </form>
                        <div className="form-group">
                            <p style={{ color: "#ff0000" }}>*Note: All fields are mandatory</p>
                            <p><b>FO numbers:</b> List of FO numbers</p>
                        </div>
                        <div className="form-group">
                            <a className="btn btn-primary" href={require('../../assets/files/Hot_loads_file.csv')} target="_blank">Sample Template</a>
                        </div>
                    </div>
                </div>
            </div>
            <div className={"overlay-part " + (overlay)} style={{ zIndex: "10" }}onClick={closeSlider}></div>
            <button type="button" title="Bulk Upload Consignment's as Hot Loads" className="btn btn-warning float-right action_btn main-page-button" style={{ marginLeft: "10px" }} onClick={bulkUploadClick}>Bulk Upload Hot Loads</button>
        </>
    )
}
export default memo(BulkUploadHL)